// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fetching-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.95);
  backdrop-filter: blur(8px);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fetching-overlay-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.5rem;
  padding: 3rem;
  max-width: 500px;
  width: 90%;
}

.legal-animation {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scales-container {
  position: relative;
  width: 140px;
  height: 140px;
  animation: scaleFloat 3s ease-in-out infinite;
}

@keyframes scaleFloat {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-15px) rotate(3deg);
  }
}
.scale-beam {
  position: absolute;
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
  width: 110px;
  height: 5px;
  background: linear-gradient(135deg, #d4af37, #f4e4a6);
  border-radius: 3px;
  box-shadow: 0 4px 20px rgba(212, 175, 55, 0.6);
  animation: beamTilt 2.5s ease-in-out infinite;
}

@keyframes beamTilt {
  0%, 100% {
    transform: translateX(-50%) rotate(0deg);
  }
  25% {
    transform: translateX(-50%) rotate(-5deg);
  }
  75% {
    transform: translateX(-50%) rotate(5deg);
  }
}
.scale-left-pan,
.scale-right-pan {
  position: absolute;
  top: 40px;
  width: 35px;
  height: 22px;
  border: 3px solid #d4af37;
  border-radius: 50% 50% 45% 45%;
  background: linear-gradient(135deg, rgba(212, 175, 55, 0.15), rgba(244, 228, 166, 0.25));
  box-shadow: 0 2px 15px rgba(212, 175, 55, 0.4);
  animation: panBounce 2.5s ease-in-out infinite;
}

.scale-left-pan {
  left: 2px;
}

.scale-right-pan {
  right: 2px;
  animation-delay: 1.25s;
}

@keyframes panBounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(10px);
  }
}
.scale-base {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  width: 8px;
  height: 70px;
  background: linear-gradient(180deg, #d4af37, #b8941f);
  border-radius: 4px;
  box-shadow: 0 6px 20px rgba(212, 175, 55, 0.4);
}

.circular-progress {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-ring {
  width: 220px;
  height: 220px;
  transform: rotate(-90deg);
}

.progress-ring-circle {
  fill: none;
  stroke: #3b82f6;
  stroke-width: 3;
  stroke-dasharray: 339.292;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: progressRotate 2s ease-in-out infinite;
  filter: drop-shadow(0 0 12px rgba(59, 130, 246, 0.6));
}

@keyframes progressRotate {
  0% {
    stroke-dashoffset: 339.292;
  }
  50% {
    stroke-dashoffset: 84.823;
  }
  100% {
    stroke-dashoffset: 339.292;
  }
}
.loading-text-container {
  text-align: center;
  color: white;
}

.loading-title {
  font-size: 1.875rem;
  font-weight: 600;
  margin: 0 0 0.875rem 0;
  background: linear-gradient(135deg, #ffffff, #e2e8f0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.5px;
  animation: titlePulse 2.5s ease-in-out infinite;
}

@keyframes titlePulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.85;
    transform: scale(1.02);
  }
}
.loading-subtitle {
  font-size: 1rem;
  color: #94a3b8;
  margin: 0 0 1.25rem 0;
  font-weight: 400;
  letter-spacing: 0.3px;
}

.loading-dots {
  display: flex;
  gap: 0.625rem;
  justify-content: center;
  align-items: center;
  margin-top: 1.25rem;
}

.dot {
  width: 10px;
  height: 10px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  border-radius: 50%;
  animation: dotBounce 1.4s ease-in-out infinite;
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.6);
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotBounce {
  0%, 80%, 100% {
    transform: scale(0.7);
    opacity: 0.4;
  }
  40% {
    transform: scale(1.3);
    opacity: 1;
  }
}
@media (max-width: 768px) {
  .fetching-overlay-content {
    padding: 2rem;
    gap: 2rem;
  }
  .legal-animation {
    width: 160px;
    height: 160px;
  }
  .scales-container {
    width: 120px;
    height: 120px;
  }
  .scale-beam {
    width: 90px;
  }
  .progress-ring {
    width: 180px;
    height: 180px;
  }
  .loading-title {
    font-size: 1.5rem;
  }
  .loading-subtitle {
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .fetching-overlay-content {
    padding: 1.5rem;
    gap: 1.5rem;
  }
  .legal-animation {
    width: 140px;
    height: 140px;
  }
  .scales-container {
    width: 100px;
    height: 100px;
  }
  .scale-beam {
    width: 80px;
  }
  .progress-ring {
    width: 160px;
    height: 160px;
  }
  .loading-title {
    font-size: 1.35rem;
  }
  .loading-subtitle {
    font-size: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FetchingOverlay/FetchingOverlay.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,0BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;AADF;;AAIA;EACE;IACE,UAAA;EADF;EAGA;IACE,UAAA;EADF;AACF;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AAFF;;AAMA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,6CAAA;AAHF;;AAMA;EACE;IACE,qCAAA;EAHF;EAKA;IACE,yCAAA;EAHF;AACF;AAMA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,qDAAA;EACA,kBAAA;EACA,8CAAA;EACA,6CAAA;AAJF;;AAOA;EACE;IACE,wCAAA;EAJF;EAMA;IACE,yCAAA;EAJF;EAMA;IACE,wCAAA;EAJF;AACF;AAOA;;EAEE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,8BAAA;EACA,wFAAA;EACA,8CAAA;EACA,8CAAA;AALF;;AAQA;EACE,SAAA;AALF;;AAQA;EACE,UAAA;EACA,sBAAA;AALF;;AAQA;EACE;IACE,wBAAA;EALF;EAOA;IACE,2BAAA;EALF;AACF;AAQA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,YAAA;EACA,qDAAA;EACA,kBAAA;EACA,8CAAA;AANF;;AAUA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;AAPF;;AAUA;EACE,UAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iDAAA;EACA,qDAAA;AAPF;;AAUA;EACE;IACE,0BAAA;EAPF;EASA;IACE,yBAAA;EAPF;EASA;IACE,0BAAA;EAPF;AACF;AAWA;EACE,kBAAA;EACA,YAAA;AATF;;AAYA;EACE,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qDAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;EACA,+CAAA;AATF;;AAYA;EACE;IACE,UAAA;IACA,mBAAA;EATF;EAWA;IACE,aAAA;IACA,sBAAA;EATF;AACF;AAYA;EACE,eAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;AAVF;;AAcA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,WAAA;EACA,YAAA;EACA,qDAAA;EACA,kBAAA;EACA,8CAAA;EACA,4CAAA;AAXF;;AAcA;EACE,qBAAA;AAXF;;AAcA;EACE,qBAAA;AAXF;;AAcA;EACE;IACE,qBAAA;IACA,YAAA;EAXF;EAaA;IACE,qBAAA;IACA,UAAA;EAXF;AACF;AAeA;EACE;IACE,aAAA;IACA,SAAA;EAbF;EAgBA;IACE,YAAA;IACA,aAAA;EAdF;EAiBA;IACE,YAAA;IACA,aAAA;EAfF;EAkBA;IACE,WAAA;EAhBF;EAmBA;IACE,YAAA;IACA,aAAA;EAjBF;EAoBA;IACE,iBAAA;EAlBF;EAqBA;IACE,iBAAA;EAnBF;AACF;AAsBA;EACE;IACE,eAAA;IACA,WAAA;EApBF;EAuBA;IACE,YAAA;IACA,aAAA;EArBF;EAwBA;IACE,YAAA;IACA,aAAA;EAtBF;EAyBA;IACE,WAAA;EAvBF;EA0BA;IACE,YAAA;IACA,aAAA;EAxBF;EA2BA;IACE,kBAAA;EAzBF;EA4BA;IACE,kBAAA;EA1BF;AACF","sourcesContent":["// FetchingOverlay.scss\r\n\r\n.fetching-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(15, 23, 42, 0.95);\r\n  backdrop-filter: blur(8px);\r\n  z-index: 99999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  animation: fadeIn 0.3s ease-in-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.fetching-overlay-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 2.5rem;\r\n  padding: 3rem;\r\n  max-width: 500px;\r\n  width: 90%;\r\n}\r\n\r\n// Legal Scales Animation - Main Focus\r\n.legal-animation {\r\n  position: relative;\r\n  width: 200px;\r\n  height: 200px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.scales-container {\r\n  position: relative;\r\n  width: 140px;\r\n  height: 140px;\r\n  animation: scaleFloat 3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes scaleFloat {\r\n  0%, 100% {\r\n    transform: translateY(0) rotate(0deg);\r\n  }\r\n  50% {\r\n    transform: translateY(-15px) rotate(3deg);\r\n  }\r\n}\r\n\r\n.scale-beam {\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 110px;\r\n  height: 5px;\r\n  background: linear-gradient(135deg, #d4af37, #f4e4a6);\r\n  border-radius: 3px;\r\n  box-shadow: 0 4px 20px rgba(212, 175, 55, 0.6);\r\n  animation: beamTilt 2.5s ease-in-out infinite;\r\n}\r\n\r\n@keyframes beamTilt {\r\n  0%, 100% {\r\n    transform: translateX(-50%) rotate(0deg);\r\n  }\r\n  25% {\r\n    transform: translateX(-50%) rotate(-5deg);\r\n  }\r\n  75% {\r\n    transform: translateX(-50%) rotate(5deg);\r\n  }\r\n}\r\n\r\n.scale-left-pan,\r\n.scale-right-pan {\r\n  position: absolute;\r\n  top: 40px;\r\n  width: 35px;\r\n  height: 22px;\r\n  border: 3px solid #d4af37;\r\n  border-radius: 50% 50% 45% 45%;\r\n  background: linear-gradient(135deg, rgba(212, 175, 55, 0.15), rgba(244, 228, 166, 0.25));\r\n  box-shadow: 0 2px 15px rgba(212, 175, 55, 0.4);\r\n  animation: panBounce 2.5s ease-in-out infinite;\r\n}\r\n\r\n.scale-left-pan {\r\n  left: 2px;\r\n}\r\n\r\n.scale-right-pan {\r\n  right: 2px;\r\n  animation-delay: 1.25s;\r\n}\r\n\r\n@keyframes panBounce {\r\n  0%, 100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(10px);\r\n  }\r\n}\r\n\r\n.scale-base {\r\n  position: absolute;\r\n  bottom: 15px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 8px;\r\n  height: 70px;\r\n  background: linear-gradient(180deg, #d4af37, #b8941f);\r\n  border-radius: 4px;\r\n  box-shadow: 0 6px 20px rgba(212, 175, 55, 0.4);\r\n}\r\n\r\n// Circular Progress - Clean and Smooth\r\n.circular-progress {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.progress-ring {\r\n  width: 220px;\r\n  height: 220px;\r\n  transform: rotate(-90deg);\r\n}\r\n\r\n.progress-ring-circle {\r\n  fill: none;\r\n  stroke: #3b82f6;\r\n  stroke-width: 3;\r\n  stroke-dasharray: 339.292;\r\n  stroke-dashoffset: 0;\r\n  stroke-linecap: round;\r\n  animation: progressRotate 2s ease-in-out infinite;\r\n  filter: drop-shadow(0 0 12px rgba(59, 130, 246, 0.6));\r\n}\r\n\r\n@keyframes progressRotate {\r\n  0% {\r\n    stroke-dashoffset: 339.292;\r\n  }\r\n  50% {\r\n    stroke-dashoffset: 84.823;\r\n  }\r\n  100% {\r\n    stroke-dashoffset: 339.292;\r\n  }\r\n}\r\n\r\n// Loading Text - Clean and Professional\r\n.loading-text-container {\r\n  text-align: center;\r\n  color: white;\r\n}\r\n\r\n.loading-title {\r\n  font-size: 1.875rem;\r\n  font-weight: 600;\r\n  margin: 0 0 0.875rem 0;\r\n  background: linear-gradient(135deg, #ffffff, #e2e8f0);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  letter-spacing: 0.5px;\r\n  animation: titlePulse 2.5s ease-in-out infinite;\r\n}\r\n\r\n@keyframes titlePulse {\r\n  0%, 100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    opacity: 0.85;\r\n    transform: scale(1.02);\r\n  }\r\n}\r\n\r\n.loading-subtitle {\r\n  font-size: 1rem;\r\n  color: #94a3b8;\r\n  margin: 0 0 1.25rem 0;\r\n  font-weight: 400;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n// Animated Dots - Simple and Elegant\r\n.loading-dots {\r\n  display: flex;\r\n  gap: 0.625rem;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 1.25rem;\r\n}\r\n\r\n.dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\r\n  border-radius: 50%;\r\n  animation: dotBounce 1.4s ease-in-out infinite;\r\n  box-shadow: 0 0 15px rgba(59, 130, 246, 0.6);\r\n}\r\n\r\n.dot:nth-child(2) {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.dot:nth-child(3) {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n@keyframes dotBounce {\r\n  0%, 80%, 100% {\r\n    transform: scale(0.7);\r\n    opacity: 0.4;\r\n  }\r\n  40% {\r\n    transform: scale(1.3);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n// Responsive Design\r\n@media (max-width: 768px) {\r\n  .fetching-overlay-content {\r\n    padding: 2rem;\r\n    gap: 2rem;\r\n  }\r\n\r\n  .legal-animation {\r\n    width: 160px;\r\n    height: 160px;\r\n  }\r\n\r\n  .scales-container {\r\n    width: 120px;\r\n    height: 120px;\r\n  }\r\n\r\n  .scale-beam {\r\n    width: 90px;\r\n  }\r\n\r\n  .progress-ring {\r\n    width: 180px;\r\n    height: 180px;\r\n  }\r\n\r\n  .loading-title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .loading-subtitle {\r\n    font-size: 0.9rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .fetching-overlay-content {\r\n    padding: 1.5rem;\r\n    gap: 1.5rem;\r\n  }\r\n\r\n  .legal-animation {\r\n    width: 140px;\r\n    height: 140px;\r\n  }\r\n\r\n  .scales-container {\r\n    width: 100px;\r\n    height: 100px;\r\n  }\r\n\r\n  .scale-beam {\r\n    width: 80px;\r\n  }\r\n\r\n  .progress-ring {\r\n    width: 160px;\r\n    height: 160px;\r\n  }\r\n\r\n  .loading-title {\r\n    font-size: 1.35rem;\r\n  }\r\n\r\n  .loading-subtitle {\r\n    font-size: 0.85rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
